import React from 'react'
import { Panel, IPanelProps } from 'core/decorators/Panel';
import CourseCheckoutConfig from './CourseCheckout'
import ServiceRegistry from 'core/util/ServiceRegistry';
import ILocalCacheService from 'core/service/cache/ILocalCacheService';
import { Query } from 'core/api/typedQuery';
import Loading from 'common/fragments/Loading';
import NonIdealState from 'common/fragments/NonIdealState';
import { RowsView } from 'common/views/rows/Rows.view';
import { BlockView, BlockVariant } from 'common/views/block/BlockView.view';
import { CardField, CardVariant, CardView } from 'common/views/card/Card.view';
import HeadingView, { HeadingVariant } from 'common/views/heading/Heading.view';
import { NumericInput, Tooltip, Position, Button, Intent, AnchorButton } from '@blueprintjs/core';
import { FlexJustify, FlexLeft, FlexRight } from 'common/fragments/Flex';
import CartDetails from './entities/CartDetails';
import { ButtonView, ButtonVariant } from 'common/views/button/Button.view';
import DiscountDetails from 'panels/bundleEntries/component/DiscountDetails';
import { Payment } from './entities/Payment';
import { toInteger } from 'core/util/StringUtil';
import PageLinkView from 'common/views/pageLink/PageLink.view';
import { ForumToaster } from 'panels/forum/forumActions';
import PageRedirect from 'common/fragments/PageRedirect';
import { Order } from './entities/Order';
import labelProvider from "./CourseCheckout.label";
import { v4 as generateUuid } from "uuid";
import './CourseCheckout.css'
import IconView from 'common/views/icon/Icon.view';
import Label from 'core/components/label/Label';
import { CreditsPayment } from './entities/CreditsPayment';
import VerticalCenter from 'common/fragments/VerticalCenter';

interface ICartParam {
	entryQuantities: EntryQuantity[];
	useCredits:Boolean;
	organizationId:number;
}

class EntryQuantity {
    entryId: number;
    quantity: number;
    uniqueRefreshId: any;
    constructor(entryId: number, quantity: number, uniqueRefreshId: any) {
        this.entryId = entryId;
        this.quantity = quantity;
        this.uniqueRefreshId = uniqueRefreshId;
    }
}

let CartDetailsQuery = Query.queryOne<CartDetails, ICartParam>(CartDetails);
let quantityMap = new Map();
const cacheService = ServiceRegistry.get(ILocalCacheService);
const { Labels } = labelProvider;
@Panel({ id: "course-checkout", configClass: CourseCheckoutConfig, pageParams: true ,labelProvider})
export class CourseCheckoutPanel extends React.PureComponent<IPanelProps<CourseCheckoutConfig>> {
	state = { isloading: false, redirectSucesss: false, reload: false }
	
    public render() {
		var payment = ServiceRegistry.get(ILocalCacheService).getString("paymentType");
        const params = {
			entryQuantities: this.cartEntries(cacheService.get('cart')),
			useCredits:payment ==="entryvar.credits",			
			organizationId:cacheService.getNumber("orgId")
        };

		CartDetailsQuery = Query.queryOne<CartDetails, ICartParam>(CartDetails);
		this.setState({ isloading: false })
		this.setState({ reload: false })


		if (this.state.redirectSucesss) {
			return <PageRedirect data={this.props.config.redirectSuccess} />
		}
				    return (
						<div>
								{this.state.isloading ?
										<Loading key="loading" /> : null
								}
								<CartDetailsQuery key="query" params={params} autoLoad={true}   >
										{
												({ data, loading }) => {
														if (loading) {
																return <Loading key="loading" />;
														}
							       if ((!data || data.cartItems.length === 0)) {
																return (
																		<NonIdealState
																				key="empty"
																				title={<Labels.CheckoutEmpty />}
																				description={<Labels.DescriptionEmpty />}

																		/>
																);
														}
													if (payment==='entryvar.credits') {
														return (
															<FlexJustify >
																<FlexLeft style={{ width: '80%' }} >
																	<BlockView key="primary" variant={BlockVariant.CARD_CONTENT} style={{ flexGrow: 1 }} viewKey="checkout-box">
																		<RowsView key='rowview' viewKey='rowview' >
																			{data.cartItems.map(this.renderCartDetails)}
																		</RowsView>
																	</BlockView>
																</FlexLeft>
																<FlexLeft style={{ width: '20%' }}>
																	<BlockView key="primary" variant={BlockVariant.CARD_CONTENT} style={{ flexGrow: 1 }}
																		className="credit-checkout-summary"
																		viewKey="credit-checkout-summary">


																	<CardView variant={CardVariant.SURFACE} viewKey="credit-checkout-summary">		
																		<CardField>
																			<HeadingView variant={HeadingVariant.H1} viewKey="credit-checkout-heading"
																				children={`CHECKOUT`} />
																		</CardField>
																		<CardField>
																			<FlexJustify>
																				<HeadingView variant={HeadingVariant.H6} viewKey="available-credits"
																					children={`Current Credit Available :`} />
																				<HeadingView variant={HeadingVariant.H6} viewKey="available-credits-right"																					
																					children={`${isNaN(data.availableCredits)? 0: data.availableCredits}`} />																						
																			</FlexJustify>
																		</CardField>
																		<CardField>
																			<FlexJustify>
																				<HeadingView variant={HeadingVariant.H6} viewKey="required-credits"
																				children={`Credits for this purchase :  `} />
																				<HeadingView variant={HeadingVariant.H6} viewKey="required-credits-right"																					
																					children={`${isNaN(data.total)? 0: data.total}`} />																						
																			</FlexJustify>
																		</CardField>
																		<CardField>
																			<FlexJustify>
																				<HeadingView variant={HeadingVariant.H6} viewKey="remaining-credits"
																				children={`Total Credis after purchase :  `} />
																				<HeadingView variant={HeadingVariant.H6} viewKey="remaining-credits-right"
																					children={`${isNaN(data.remainingCredits)? 0: data.remainingCredits}`} />																						
																			</FlexJustify>
																		</CardField>	
																		<br></br>									
																			<VerticalCenter>
																				<form onSubmit={(e) => this.createCreditPurchase(e, data)}>
																					<PageLinkView viewKey="distribute-seats">
																						<ButtonView variant={ButtonVariant.PRIMARY} 
																							 button disabled={data.remainingCredits < 0} 
																							viewKey="credit-course-purchase" >
																							<Labels.Purchase />
																						</ButtonView>
																					</PageLinkView>
																				</form>	
																			</VerticalCenter>
																			<br></br>	
																		</CardView>
																										
																	</BlockView>
																</FlexLeft>
															</FlexJustify>

														);
													}
													if (payment!== "entryvar.credits"){
														return (

															<div>
																<FlexJustify >
																	<FlexLeft style={{ width: '80%' }}>
																		<BlockView key="primary" variant={BlockVariant.CARD_CONTENT} style={{ flexGrow: 1 }} viewKey="checkout-box">
																			<RowsView key='rowview' viewKey='rowview' >
																				{data.cartItems.map(this.renderCartDetails)}
																			</RowsView>
																		</BlockView>
																	</FlexLeft>
																	<FlexLeft style={{ width: '20%' }}>
																		<BlockView key="primary" variant={BlockVariant.CARD_CONTENT} style={{ flexGrow: 1 }}
																			className="checkout-summary"
																			viewKey="checkout-summary">
																			<CardField>
																				<HeadingView viewKey="title"
																					children={`Total:  $ ` + data.total} />
																			</CardField>
																			<br></br>

																			<form onSubmit={(e) => this.createPurchase(e, data)}>
																				<CardField>
																					<input name="cardNumber" placeholder="Card Number" type="text"
																						required={true}></input>
																				</CardField>
																				<br></br>
																				<CardField>
																					<input name="name" placeholder="Name" required={true}></input>
																				</CardField>
																				<br></br>

																				<CardField>
																					<input name="expiryMonth" placeholder="Expiry Month" required={true}
																						maxLength={2}></input>
																				</CardField>
																				<br></br>

																				<CardField>
																					<input name="expiryYear" placeholder="Expiry Year" required={true} maxLength={4}></input>
																				</CardField>
																				<br></br>

																				<CardField>
																					<input name="ccv" placeholder="CCV" required={true} maxLength={4} min={4}></input>
																				</CardField>
																				<br></br>
																				<div className="flex-justify">
																					<PageLinkView viewKey="distribute-seats">
																						<ButtonView variant={ButtonVariant.PRIMARY}
																							button disabled={data.total === 0}
																							viewKey="course-purchase">
																							<Labels.Purchase />
																						</ButtonView>
																					</PageLinkView>
																				</div>
																			</form>
																		</BlockView>
																	</FlexLeft>
																</FlexJustify>
															</div>

														);
									}
													
												}
										}
								</CartDetailsQuery></div>
				);
		}

		private renderCartDetails = (cartDetails) => {
				const headerViewKey = `${cartDetails.discountApplied ? 'discounted-course-price' : 'course-price'}`;
				return (
						<BlockView key="primary" variant={BlockVariant.CARD_CONTENT} style={{ flexGrow: 1 }} viewKey="checkout-box"
								className="checkout-box">
								<CardField>
										<FlexJustify >
												<FlexLeft style={{ width: '50%' }}>
														<CardField>
																<HeadingView viewKey="title"
																		children={cartDetails.name} />
																<div className="eligible-institution-text">
																		<HeadingView variant={HeadingVariant.H6} viewKey='eligible-institutions'
																				children={`(${cartDetails.eligibleInstitutions}) Institution(s) Eligible`} />
																</div>
														</CardField>
												</FlexLeft>

												<FlexLeft style={{ width: '30%' }}>
														<CardField>
																<NumericInput size={1} value={cartDetails.quantity || 1}
																		onBlur={(e) => this.handleBlurChange(e, cartDetails)}
																		onButtonClick={(e) => this.handleClick(e, cartDetails)}
																		min={1}></NumericInput>

																<Tooltip content={<DiscountDetails
																		priceDetails={cartDetails.discounter === null ? [] : cartDetails.discounter.data}
																		position={Position.BOTTOM} />} >
																		<div className="bulk-discoint-info-text ">
																				<Labels.BulkDiscount />
																		</div>
																</Tooltip>
														</CardField>
												</FlexLeft>

												<FlexRight style={{ width: '20%' }}>
														<CardField>
																<div>
																		<HeadingView  viewKey={headerViewKey}
																				children={`${ServiceRegistry.get(ILocalCacheService).getString("paymentType") ==='entryvar.currency' ?'$':''}` + cartDetails.price.value} />
																</div>

																<FlexRight >
																		<div className={`bulk-discount-text ${cartDetails.discountApplied ? '' : 'hide-bulk-discount-icon'}`}>
																				<IconView icon="blank" viewKey="icon" />
																		</div>
																		<div className="bulk-discount-text discount-right">
																				<HeadingView variant={HeadingVariant.H6} viewKey='bulk-discount-text'
																						children={cartDetails.discountApplied ? 'Bulk Price Discount' : ''} />
																		</div>
																</FlexRight>

																<ButtonView variant={ButtonVariant.MINIMAL} icon="delete"
																		onClick={(e) => this.removeFromCart(e, cartDetails)}
																		viewKey="cart-delete-button">
																		<div className="bulk-discoint-info-text ">
																				<Label k="cart-delete" v="Remove From Cart" />
																		</div>
																</ButtonView>
														</CardField>
												</FlexRight>
										</FlexJustify>
								</CardField>

						</BlockView>
				);
		}

		private cartEntries = (cartDetails) => {
				const entries = [];
				cartDetails.map((cartDetail) => {
						entries.push(new EntryQuantity(cartDetail.entryId, cartDetail.quantity,
								cartDetail.uniqueRefreshId ? cartDetail.uniqueRefreshId : ''));
						quantityMap.set(cartDetail.entryId, cartDetail.quantity);
				});
				return entries;
		}

		private removeFromCart = (e, cartDetails) => {
				e.preventDefault();
				let cartList = [];
				cartList = this.cartEntriesDetails(cacheService.get('cart'));
				const index = cartList.findIndex((c) => c.entryId === cartDetails.id);
				cartList.splice(index, 1);
				cacheService.put('cart', cartList);
				this.setState({ reload: true });
		}

		private handleClick = (e, cartDetails) => {
				this.handleInputChange(e, cartDetails);
		}

		private handleBlurChange = (e, cartDetails) => {
				this.handleInputChange((e.target as HTMLInputElement).value, cartDetails);
		}

		private handleInputChange = (quantity, cartDetails) => {
				this.setState({ isloading: true });
				const itemDetails = {
						entryId: cartDetails.id,
						quantity: toInteger(quantity),
						name: cartDetails.name,
						uniqueRefreshId: generateUuid()
				};
				let cartList = [];
				cartList = this.cartEntriesDetails(cacheService.get('cart'));
				cacheService.remove('cart');
				const index = cartList.findIndex((c) => c.entryId === cartDetails.id);
				cartList.splice(index, 1, itemDetails);
				cacheService.put('cart', cartList);
				this.setState({ reload: true });
		}

		private cartEntriesDetails = (cartDetails) => {
				const entries = [];
				cartDetails.map((cartDetail) => {
						const itemDetails = {
								entryId: cartDetail.entryId,
								quantity: cartDetail.quantity,
								name: cartDetail.name
						};
						entries.push(itemDetails);
				});
				return entries;
		}

		private createPurchase(e, data) {
				e.preventDefault();
				const payment = {
						number: e.target.cardNumber.value, name: e.target.name.value, cardExpirationMonth: toInteger(e.target.expiryMonth.value),
						cardExpirationYear: toInteger(e.target.expiryYear.value), cardId: e.target.ccv.value, amount: data.total
				} as any;

				this.setState({ isloading: true });
				ServiceRegistry.getMutationService().create(payment, Payment)
						.then((res) => {
								console.log(res);
								if (res.entity.entityId == 0) {
										this.setState({ isloading: false });
										ForumToaster.show({
												intent: Intent.DANGER,
												message: "Purchase Failed. Please try again"
										});
								} else {
										data.cartItems.map((cartDetail, index, arr) => {
											this.createOrgEnrollments(res, cartDetail, index, arr);
										});
								}
						});
		}

		private createOrgEnrollments(res, cartDetail, index, arr) {
			const order = {
				orderId: res.entity.entityId, entryId: cartDetail.id, name: cartDetail.name,
				price: cartDetail.price.value, quantity: cartDetail.quantity,
				unitPrice: cartDetail.unitPrice.value, organizationId:cacheService.getNumber("orgId")
			} as any;
			ServiceRegistry.getMutationService().create(order, Order).then((res) => {
				if (index === arr.length - 1) {
					this.setState({ isloading: false });
					this.setState({ redirectSucesss: true });
					cacheService.put('cart', []);
					ForumToaster.show({
						intent: Intent.SUCCESS,
						message: "Purchase Successfull, You can now distribute your purchased seat throughout the eligible Institutions"
					});
				}
			}).catch((err) => {
				console.error(err);
			});
		}

		private createCreditPurchase(e, data) {
			e.preventDefault();
			const cartItems = [];
			data.cartItems.map((cartDetail) => {
				console.log(cartDetail)
				const cartItem = {
						id: cartDetail.id,
						name: cartDetail.name,
						unitPrice: cartDetail.unitPrice.value
				};
				cartItems.push(cartItem);
		});

			const payment = {
				totalCredits: data.total, organizationId: cacheService.getNumber("orgId"),
				cartItems
			} as any;

			ServiceRegistry.getMutationService().create(payment, CreditsPayment)
				.then((res) => {
					if (res.entity.entityId == 0) {
						this.setState({ isloading: false });
						ForumToaster.show({
							intent: Intent.DANGER,
							message: "Purchase Failed. Please try again"
						});
					} else {
						data.cartItems.map((cartDetail, index, arr) => {
							this.createOrgEnrollments(res, cartDetail, index, arr);
						});
					}
				});
		
		}

}




// WEBPACK FOOTER //
// ./src/panels/checkout/CourseCheckout.panel.tsx